<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9209 12.5712C15.1806 10.3115 15.1806 6.64792 12.9209 4.38826C10.6612 2.1286 6.99762 2.1286 4.73796 4.38826C2.4783 6.64792 2.4783 10.3116 4.73796 12.5712C6.99762 14.8309 10.6612 14.8309 12.9209 12.5712ZM12.9209 12.5712L17.2342 16.8764"
      stroke="currentColor"
      :stroke-width="bigger ? '0.8' : '1.5'"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconSearch',
  props: {
    bigger: {
      type: Boolean,
      default: false
    }
  }
}
</script>
